import {ready} from '../main/utils';
import loadDropSpotFeaturesCarousel from './drop-spot-features-carousel';
import loadProductCategory from './product-category';
import loadProductCarousel from './product-carousel';
import loadProductType from './product-type';
import loadProduct from './product';
import loadSpecRequest from './request-spec';

ready(() => {
  loadDropSpotFeaturesCarousel();
  loadProductCategory();
  loadProductType();
  loadProduct();
  loadProductCarousel();
  loadSpecRequest();
});
